module.exports = __webpack_public_path__ + "img/1.994540aa.png";